import { api } from "@/modules/api";
import { AppStore } from "@/store";
import { waitForLiveUpdate } from "@/store/sync/utils";
import { runInAction } from "mobx";

export const transformNoteWithVoice = async ({
  noteId,
  capturedAudioId,
  sessionId,
  fromSource,
  store,
}: {
  noteId: string;
  capturedAudioId: string;
  sessionId?: string;
  fromSource?: boolean;
  store: AppStore;
}) => {
  try {
    const note = await store.notes.getAsync(noteId);
    if (!note) return { success: false, error: "Note not found" };
    runInAction(() => (note.isProcessingSuggestion = true));

    try {
      const response = await api.post("/v2/voice/transform_note", {
        body: {
          note_id: noteId,
          captured_audio_id: capturedAudioId,
          from_source: fromSource,
          session_id: sessionId,
        },
      });
      if (response.response.ok) {
        store.sync.syncQuery.forceRefetch();
        await waitForLiveUpdate(async () => {
          try {
            const spaceAccountNote = await store.spaceAccountNotes.localTable.get(
              note.spaceAccountNoteId
            );
            return !!spaceAccountNote?.model_data?.suggestion_data;
          } catch (_) {
            return false;
          }
        });

        return { success: true };
      } else {
        throw new Error(response.error?.detail);
      }
    } finally {
      runInAction(() => (note.isProcessingSuggestion = false));
    }
  } catch (error) {
    return { success: false, error: error instanceof Error ? error.message : "Unknown error" };
  }
};
